module.exports = __webpack_public_path__ + "media/images/ico-basic-info-8f51a36b977ace925a008dad79f34061.svg";